<template>
  <Body class="lp disp-scroll" :scroll="getScroll()">
    <PrivacyPolicyContent/>
    <a href="#top" class="to-top" v-if="isVisible" v-smooth-scroll><img src="@/assets/lp/to_top.png" alt="採用プラットフォームの説明へ"></a>
    <div class="lp-bottom-text">
      <p><a class="campany-link" href="https://www.robottte.com/" target="blank">運用会社はこちら</a></p>
      <p>Copyright(c) 2021 robottte Co., Ltd. All Rights Reserved.</p>
    </div>
  </Body>
</template>

<script>
import PrivacyPolicyContent from '@/views/PrivacyPolicy/PrivacyPolicyContent'
export default {
  name: 'PrivacyPolicyBody',
  componentName: 'PrivacyPolicyBody',
  components: {
    PrivacyPolicyContent,
  },
  data () {
    return {
      internal: {},
      isVisible: false
    }
  },
  created() {
    console.debug('*** Start *** created')
    window.addEventListener('scroll', this.getScroll);
    console.debug('*** End *** created')
  },
  destroyed() {
    console.debug('*** Start *** destroyed')
    window.removeEventListener('scroll', this.getScroll);
    console.debug('*** End *** destroyed')
  },
  methods: {
    getScroll () {
      console.debug('*** Start *** getScroll')
      console.log('================= ' + window.scrollY + ' =================')
      if (window.scrollY > 150) this.isVisible = true
      else this.isVisible = false
      console.debug('*** End *** getScroll')
    }
  }
}
</script>

<style scoped>
.lp-bottom-text {
  width: 100%;
	text-align: center;
  background: #1B2C61;
  color: white;
  padding-bottom: 6px;
  padding-top: 2px;
}
.to-top {
  position: fixed;
  bottom: 2%;
  right: 1%;
  height: 64px;
  width: 64px;
  background: #1B2C61;
  box-shadow: 2px 2px 5px rgba(0,0,0,0.3);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.to-top > img {
  height: 50px;
  width: 50px;
}
.campany-link {
  color: #ffffff;
  border-bottom: solid thin #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/PrivacyPolicy/PrivacyPolicyBody.vue